import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseEntity } from 'app/model';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { mapJsonObjectToClient, mapJsonObjectToServer } from '.';
import { extractData } from '../utils/entity-helper';
import { PermissionActions } from 'app/model/enums/permission-actions';

interface AdminPermissionsResponse {
  adminId: number;
  actionIds: PermissionActions[];
}

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private httpClient: HttpClient) {}

  getPermissions<T extends BaseEntity>(entity: T, forceRefresh?: boolean): Observable<string[] | null> {
    if (!entity) {
      return of(null);
    }

    if (forceRefresh || !entity._permissions$) {
      const typeName = entity.entityType.shortName;
      const data = mapJsonObjectToServer(extractData(entity, true, true));

      entity._permissions$ = this.httpClient
        .post<AdminPermissionsResponse[]>(`${environment.apiRoot}/permissions`, {
          typeName,
          data,
        })
        .pipe(
          map((response) => {
            response = mapJsonObjectToClient(response);
            return response.flatMap((v) => v.actionIds).map((v) => v.toString());
          }),
          shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    return entity._permissions$;
  }
}
